import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoadingCustomer: false,
  isLoadingCustomerById: false,
  isLoadingSummary: false,
  isLoadingSummaryAutonomous: false,
  isLoadingPurchaseFrequency: false,
  isLoadingInvoiceHistory: false,
  isLoadingPrizeHistory: false,
  isLoadingProductsConsumed: false,
  isLoadingPoints: false,
  isLoadingPostPoints: false,
  isLoadingExcelReport: false,
  isLoadingExtraPoints: false,
  customers: [],
  customerDetail: {},
  customerSummary: [],
  customerSummaryTotals: [],
  customerAutonomousSummary: [],
  customerAutonomousSummaryTotals: [],
  purchaseFrecuency: {},
  invoiceHistory: {},
  loadingInvoiceDetail: false,
  invoiceDetail: null,
  isInvoiceDetailChanged: false,
  loadingPrizeDetail: false,
  prizeDetail: null,
  isPrizeDetailChanged: false,
  invoiceHistoryPage: 1,
  invoiceHistoryPageSize: 20,
  invoiceHistoryTotalPages: 0,
  prizeHistory: [],
  prizeHistoryPage: 1,
  prizeHistoryTotalPages: 0,
  productsConsumed: [],
  productsConsumedPage: 1,
  productsConsumedTotalPages: 0,
  points: {},
  postPointsMessage: {},
  count: 0,
  page: 1,
  totalPages: 0,
  customerError: null,
  customerUsers: []
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    loadCustomers: (state) => {
      state.isLoadingCustomer = true;
      state.customers = [];
    },
    setLoadingCustomer: (state, { payload }) => {
      state.isLoadingExcelReport = payload;
    },
    loadedCustomers: (state, action) => {
      state.customers = action.payload.result;
      state.count = action.payload.count;
      state.page = action.payload.page;
      state.totalPages = action.payload.totalPages;
      state.isLoadingCustomer = false;
    },
    search: (state, { payload }) => {
      state.isLoadingCustomer = true;
      state.page = 1;
      state.customers = payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setloadingCustomerById: (state, { payload }) => {
      state.isLoadingCustomerById = payload;
    },
    loadCustomerById: (state) => {
      state.isLoadingCustomerById = true;
      state.customerDetail = {};
    },
    loadedCustomerById: (state, action) => {
      state.isLoadingCustomerById = false;
      state.customerDetail = action.payload;
    },
    loadCustomerSummary: (state) => {
      state.isLoadingSummary = true;
      state.customerSummary = [];
      state.customerSummaryTotals = [];
    },
    loadedCustomerSummary: (state, action) => {
      state.isLoadingSummary = false;
      state.customerSummary = action.payload.result;
      state.customerSummaryTotals = action.payload.totals;
    },
    loadCustomerAutonomousSummary: (state) => {
      state.isLoadingSummaryAutonomous = true;
      state.customerAutonomousSummary = [];
      state.customerAutonomousSummaryTotals = [];
    },
    loadedCustomerAutonomousSummary: (state, action) => {
      state.isLoadingSummaryAutonomous = false;
      state.customerAutonomousSummary = action.payload.result;
      state.customerAutonomousSummaryTotals = action.payload.totals;
    },
    loadPurchaseFrequency: (state) => {
      state.isLoadingPurchaseFrequency = true;
      state.purchaseFrecuency = {};
    },
    loadedPurchaseFrequency: (state, action) => {
      state.isLoadingPurchaseFrequency = false;
      state.purchaseFrecuency = action.payload;
    },
    loadInvoiceHistory: (state) => {
      state.isLoadingInvoiceHistory = true;
      state.invoiceHistory = {};
    },
    loadedInvoiceHistory: (state, action) => {
      state.isLoadingInvoiceHistory = false;
      state.invoiceHistory = action.payload.result;
      state.invoiceHistoryTotalPages = action.payload.totalPages;
    },
    setInvoiceHistoryPage: (state, { payload }) => {
      state.invoiceHistoryPage = payload;
    },
    loadPrizeHistory: (state) => {
      state.isLoadingPrizeHistory = true;
      state.prizeHistory = [];
    },
    loadedPrizeHistory: (state, action) => {
      state.isLoadingPrizeHistory = false;
      state.prizeHistory = action.payload.result;
      state.prizeHistoryTotalPages = action.payload.totalPages;
    },
    setPrizeHistoryPage: (state, { payload }) => {
      state.prizeHistoryPage = payload;
    },
    loadProductsConsumed: (state) => {
      state.isLoadingProductsConsumed = true;
      state.productsConsumed = [];
    },
    loadedProductsConsumed: (state, action) => {
      state.isLoadingProductsConsumed = false;
      state.productsConsumed = action.payload.result;
      state.productsConsumedTotalPages = action.payload.totalPages;
    },
    setProductsConsumedPage: (state, { payload }) => {
      state.productsConsumedPage = payload;
    },
    setLoadingExtraPoints: (state, { payload }) => {
      state.isLoadingExtraPoints = payload;
    },
    loadPoints: (state) => {
      state.isLoadingPoints = true;
      state.points = {};
    },
    loadedPoints: (state, action) => {
      state.isLoadingPoints = false;
      state.points = action.payload;
    },
    loadPostPoints: (state) => {
      state.isLoadingPostPoints = true;
    },
    loadedPostPoints: (state, action) => {
      state.isLoadingPostPoints = false;
      state.postPointsMessage = action.payload;
    },
    setCustomerError: (state, { payload }) => {
      state.customerError = payload;
    },
    setloadingInvoiceDetail: (state, { payload }) => {
      state.loadingInvoiceDetail = payload;
    },
    setInvoiceDetail: (state, { payload }) => {
      state.invoiceDetail = payload.result;
    },
    setIsInvoiceDetailChanged: (state, { payload }) => {
      state.isInvoiceDetailChanged = payload;
    },
    setloadingPrizeDetail: (state, { payload }) => {
      state.loadingPrizeDetail = payload;
    },
    setPrizeDetail: (state, { payload }) => {
      state.prizeDetail = payload;
    },
    setIsPrizeDetailChanged: (state, { payload }) => {
      state.isPrizeDetailChanged = payload;
    },
    updateCustomerDetail: (state, { payload }) => {
      if (!state.customerDetail) return;

      state.customerDetail = {
        ...state.customerDetail,
        name: payload.name || state.customerDetail.name,
        province_id: payload.province_id || state.customerDetail.province_id,
        province: payload.province || state.customerDetail.province,
        canton_id: payload.canton_id || state.customerDetail.canton_id,
        canton: payload.canton || state.customerDetail.canton,
        district_id: payload.district_id || state.customerDetail.district_id,
        district: payload.district || state.customerDetail.district,
        address: payload.address || state.customerDetail.address,
        phone: payload.phone || state.customerDetail.phone,
      };
    },
    updateUserBlocked: (state, { payload }) => {
      if (state.customerDetail) {
        state.customerDetail.userBlocked = payload;
      }
    },
    updateMaycaCode: (state, { payload }) => {
      const updatedRecord = payload;
      const index = state.customerSummary.findIndex(
        (item) => item.customer_user_id === updatedRecord.customer_user_id
      );
      if (index !== -1) {
        state.customerSummary[index] = {
          ...state.customerSummary[index],
          customer_user_name:
            updatedRecord.name ??
            state.customerSummary[index].customer_user_name,
          customer_user_last_name:
            updatedRecord.last_name ??
            state.customerSummary[index].customer_user_last_name,
          customer_user_second_last_name:
            updatedRecord.second_last_name ??
            state.customerSummary[index].customer_user_second_last_name,
          customer_user_email:
            updatedRecord.email ??
            state.customerSummary[index].customer_user_email,
          customer_user_birthdate:
            updatedRecord.birthdate ??
            state.customerSummary[index].customer_user_birthdate,
        };
      }
    },
    updateMaycaCodeEmail: (state, { payload }) => {
      const email = payload.data.email;
      const index = state.customerSummary.findIndex(
        (item) => item.customer_user_id === payload.id
      );
      if (index !== -1) {
        state.customerSummary[index] = {
          ...state.customerSummary[index],
          customer_user_email:
            email
        };
      }
    },
    updateMaycaCodeAutonomousEmail: (state, { payload }) => {
      const email = payload.data.email;
      const index = state.customerAutonomousSummary.findIndex(
        (item) => item.customer_user_id === payload.id
      );
      if (index !== -1) {
        state.customerAutonomousSummary[index] = {
          ...state.customerAutonomousSummary[index],
          customer_user_email:
            email
        };
      }
    },
    updateAutonomousMaycaCode: (state, { payload }) => {
      const updatedRecord = payload;
      const index = state.customerAutonomousSummary.findIndex(
        (item) => item.customer_user_id === updatedRecord.customer_user_id
      );
      if (index !== -1) {
        state.customerAutonomousSummary[index] = {
          ...state.customerAutonomousSummary[index],
          customer_user_name:
            updatedRecord.name ??
            state.customerAutonomousSummary[index].customer_user_name,
          customer_user_last_name:
            updatedRecord.last_name ??
            state.customerAutonomousSummary[index].customer_user_last_name,
          customer_user_second_last_name:
            updatedRecord.second_last_name ??
            state.customerAutonomousSummary[index]
              .customer_user_second_last_name,
          customer_user_email:
            updatedRecord.email ??
            state.customerAutonomousSummary[index].customer_user_email,
          customer_user_birthdate:
            updatedRecord.birthdate ??
            state.customerAutonomousSummary[index].customer_user_birthdate,
        };
      }
    },
    setCustomerUser: (state, { payload }) => {
      state.customerUsers = payload.results;
    }
  },
});
export const customerActions = customerSlice.actions;

export default customerSlice.reducer;
